<template>
  <div class="home">
    <v-row>
      <v-col cols="12" sm="4">
        <v-hover v-slot="{ hover }" open-delay="200">
          <v-card
            style="
    background:#4DD0E1;
    background: -webkit-linear-gradient(to right, #4DD0E1, #0482fb);
    background: linear-gradient(to right, #4DD0E1, #0482fb);
  "
            color="cyan darken-1"
            :elevation="hover ? 16 : 2"
          >
            <v-row>
              <v-col cols="12" sm="8">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="mb-4">
                      <v-btn
                        class="white--text ma-2"
                        color="cyan white--text lighten-2"
                        elevation="0"
                      >
                        Nombre de dossiers sinistres
                      </v-btn>
                    </div>
                    <v-list-item-title class="headline mb-1 white--text">
                      .....
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text"
                      >.....</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="4">
                <v-avatar size="100" class="ml-n10 mt-6" tile>
                  <v-img src="wallet.png"></v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot="{ hover }" open-delay="200">
          <v-card
            style="
    background:#F06292;
    background: -webkit-linear-gradient(to right, #F06292, #0482fb);
    background: linear-gradient(to right, #F06292, #0482fb);
  "
            color="pink darken-1"
            :elevation="hover ? 16 : 2"
          >
            <v-row>
              <v-col cols="12" sm="8">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="mb-4">
                      <v-btn
                        class="white--text ma-2"
                        color="pink white--text lighten-2"
                        elevation="0"
                      >
                        Nombre de dossiers traités
                      </v-btn>
                    </div>
                    <v-list-item-title class="headline mb-1 white--text">
                      .....
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text"
                      >.....</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="4">
                <v-avatar size="100" class="ml-n10 mt-6" tile>
                  <v-img src="wallet.png"></v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="4">
        <v-hover v-slot="{ hover }" open-delay="200">
          <v-card
            style="
    background:#FB8C00;
    background: -webkit-linear-gradient(to right, #FB8C00, #0482fb);
    background: linear-gradient(to right, #FB8C00, #0482fb);
  "
            color="orange darken-1"
            :elevation="hover ? 16 : 2"
          >
            <v-row>
              <v-col cols="12" sm="8">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="mb-4">
                      <v-btn
                        class="white--text ma-2"
                        color="orange white--text lighten-2"
                        elevation="0"
                      >
                        Nombre de dossiers en Suspens
                      </v-btn>
                    </div>
                    <v-list-item-title class="headline mb-1 white--text">
                      <v-row>
                        <v-col>
                          .....
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item-subtitle class="white--text"
                      >.....</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="4">
                <v-avatar size="100" class="ml-n10 mt-6" tile>
                  <v-img src="wallet.png"></v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card class="elevation-0" height="100%">
          <v-app-bar flat color="rgba(0,0,0,0)">
            <v-toolbar-title class="title black--text pl-0 ml-2">
              Point graphique
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="#0482fb" class="white--text mr-2">Semaine</v-btn>
            <v-btn color="#0482fb lighten-4" class="#0482fb--text ">Mois</v-btn>
          </v-app-bar>
          <v-sparkline
            :fill="fill"
            :line-width="width"
            :padding="padding"
            :smooth="radius || false"
            :value="value"
            auto-draw
            color="#0482fb"
          ></v-sparkline>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card class="elevation-0" height="100%">
          <v-app-bar flat color="rgba(0,0,0,0)">
            <v-toolbar-title class="title black--text pl-0 ml-2">
              Point sur l'activité
            </v-toolbar-title>
          </v-app-bar>
          <v-app-bar flat color="rgba(0,0,0,0)" class="mb-10">
            <v-btn
              class="white--text ma-2"
              fab
              color="purple lighten-4"
              elevation="0"
            >
              <v-img
                src="../assets/sheet.png"
                max-height="50"
                width="50"
                alt="logo"
              ></v-img>
            </v-btn>
            <v-toolbar-title class="title black--text ml-2">
              Dossiers Enregistrés
              <span class="caption"><br />Par rapport à la semaine passée</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title class="subtitle-1 black--text ml-2">
              ..... Fcfa
            </v-toolbar-title>
            <v-icon color="green" class="ml-2">fas fa-long-arrow-alt-up</v-icon>
          </v-app-bar>
          <v-app-bar flat color="rgba(0,0,0,0)">
            <v-btn
              class="white--text ma-2"
              fab
              color="green lighten-4"
              elevation="0"
            >
              <v-img
                src="../assets/sheetMake.png"
                max-height="50"
                width="50"
                alt="logo"
              ></v-img>
            </v-btn>
            <v-toolbar-title class="title black--text ml-2">
              Dossiers Réglés
              <span class="caption"><br />Par rapport à la semaine passée</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title class="subtitle-1 black--text ml-2">
              ..... Fcfa
            </v-toolbar-title>
            <v-icon color="red" class="ml-2">fas fa-long-arrow-alt-down</v-icon>
          </v-app-bar>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" class="mt-10">
        <v-card class="elevation-0" height="100%">
          <v-row>
            <v-col cols="12" sm="4">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="mb-4">Evolution Annuelle</div>
                  <v-list-item-title class="headline mb-1 black--text mb-2">
                    ..... Fcfa
                  </v-list-item-title>
                  <v-list-item-subtitle class="grey--text"
                    >..... Fcfa</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="8">
              <v-sparkline
                :value="value"
                :smooth="radius || false"
                :padding="padding"
                :line-width="width"
                :stroke-linecap="lineCap"
                :fill="fills"
                :type="type"
                :auto-line-width="autoLineWidth"
                auto-draw
                color="red"
              >
              </v-sparkline>
              <v-card-actions class="justify-end">
                <v-btn class="white--text ma-2" text color="green">
                  <v-icon class="mt-n2 pr-2">fas fa-sort-down</v-icon> 8.5
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" class="mt-10">
        <v-card flat color="#fff" height="100%">
          <v-row>
            <v-col cols="12" sm="6" class="">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="mb-4">Rendement Mensuel</div>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-progress-circular
                        rotate="360"
                        size="100"
                        width="15"
                        value="70"
                        color="teal"
                      >
                        70%
                      </v-progress-circular>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-list-item-subtitle class="grey--text mt-8"
                        >..... FCFA</v-list-item-subtitle
                      >
                      <v-list-item-subtitle class="grey--text"
                        >..... FCFA</v-list-item-subtitle
                      >
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-sol cols="12" sm="6" align="center">
              <v-list-item two-line class="mt-10">
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1 black--text">
                    ..... FCFA
                  </v-list-item-title>
                  <v-list-item-subtitle class="grey--text"
                    >Totalité</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-sol>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    tab: null,
    text: "center",
    fill: true,
    padding: 8,
    radius: 10,
    value: [0, 2, 4, 16, 50, 100, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    width: 2,
    lineCap: "round",
    type: "trend",
    autoLineWidth: false,
    fills: false,
  }),
};
</script>
<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
<style scoped>
.border {
  border-right: 1px solid grey;
}
.home {
  height: 100vh;
  margin: 20px !important;
  margin-top: 50px !important;
}
</style>
